import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.701}
    height={21.286}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 34716 28752"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#221f1f}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974616839280">
        <path
          d="M23744 21673h-88l-208 938h1293l-208-938h-62c-28-578-393-6390-3755-6390-721 0-1313 206-1795 537 206-322 448-633 733-919 1064-1071 2528-1614 4351-1614 5677 0 6839 4894 7029 6007h-68l-208 938h1292l-207-938h-73c-143-946-1283-6733-7765-6733-2026 0-3665 617-4871 1832-644 649-1092 1396-1406 2127V0h-726v16520c-313-731-762-1478-1406-2127-1205-1215-2844-1832-4869-1832-6482 0-7623 5787-7765 6733h-90l-207 938h1292l-207-938h-53c190-1113 1353-6007 7030-6007 1823 0 3287 543 4351 1614 284 286 525 597 733 919-483-331-1075-537-1796-537-3361 0-3727 5812-3755 6390h-78l-207 938h1292l-207-938h-73c39-639 423-5664 3029-5664 2767 0 2980 3758 2988 3918h725c2-40 213-3918 2987-3918 2606 0 2990 5025 3028 5664z"
          className="fil0"
        />
        <path
          d="M4966 22041c-233-1151-874-1557-991-1622-11-7-24-10-38-10H2686c-14 0-27 3-39 10-116 65-757 471-990 1622-296 1459-1205 2241-1624 2533-62 42-30 136 46 136h6465c76 0 108-94 46-136-420-292-1328-1074-1624-2533zM2550 24903s-212 1470 761 1470 761-1470 761-1470H2550zM12275 24420c-233-1151-874-1556-990-1622-12-7-25-10-39-10H9995c-14 0-27 3-38 10-117 66-758 471-991 1622-296 1459-1204 2241-1624 2533-61 43-30 136 46 136h6465c77 0 108-93 47-136-420-292-1328-1074-1625-2533zM9860 27282s-213 1470 760 1470c974 0 762-1470 762-1470H9860zM34683 24574c-420-292-1328-1075-1624-2533-233-1151-874-1557-991-1622-12-7-24-10-38-10h-1251c-14 0-27 3-39 10-117 65-757 471-991 1622-295 1459-1203 2241-1623 2533-62 42-30 136 45 136h6466c76 0 107-93 46-136zM30643 24903s-213 1470 761 1470c973 0 761-1470 761-1470h-1522zM25750 24420c-234-1151-874-1556-991-1622-12-7-25-10-39-10h-1251c-14 0-27 3-39 10-116 66-757 471-990 1622-296 1459-1204 2241-1624 2533-62 43-30 136 46 136h6465c76 0 108-93 46-136-420-292-1328-1074-1623-2533zM23334 27282s-213 1470 760 1470c974 0 762-1470 762-1470h-1522z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
